import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { UserId, Uuid } from '../Base';
import { RepositoryElement } from '../Repository';

import { SubscriptionType } from './SpaceMembershipTierSubscription';

type SubscriptionMonthlyTickets = {
  monthly: number;
};

type SubscriptionYearlyTickets = {
  yearly: number;
};

type SubscriptionPermanentTickets = {
  permanent: number;
};

export type SpaceMembershipTierInventoryJson<T = number> = {
  readonly tierId: Uuid; //identifier
  readonly classroomId: Uuid; //identifier
  readonly userId: UserId; // identifier
  createdAt: T;
  lastModifiedAt: T;
  subscriptionTickets:
    | SubscriptionMonthlyTickets
    | SubscriptionYearlyTickets
    | SubscriptionPermanentTickets;
};

export class SpaceMembershipTierInventory
  extends RepositoryElement
  implements SpaceMembershipTierInventoryJson<Date>
{
  readonly tierId!: Uuid; //identifier
  readonly classroomId!: Uuid; //identifier
  readonly userId!: UserId; // identifier
  createdAt!: Date;
  lastModifiedAt!: Date;
  subscriptionTickets!:
    | SubscriptionMonthlyTickets
    | SubscriptionYearlyTickets
    | SubscriptionPermanentTickets;

  constructor(inventory: SpaceMembershipTierInventoryJson<Date | number>) {
    super();
    Object.assign(this, deepTransformTimestamp(inventory));
  }

  id(): string {
    return `${this.classroomId}_${this.userId}_${this.tierId}`;
  }

  toJSON(): SpaceMembershipTierInventoryJson {
    return deepTransformDate(
      this,
    ) as unknown as SpaceMembershipTierInventoryJson;
  }

  get tickets() {
    if ('monthly' in this.subscriptionTickets) {
      return this.subscriptionTickets.monthly;
    } else if ('yearly' in this.subscriptionTickets) {
      return this.subscriptionTickets.yearly;
    } else {
      return this.subscriptionTickets.permanent;
    }
  }

  get isPermanent() {
    return 'permanent' in this.subscriptionTickets;
  }

  get subscriptionType() {
    if ('monthly' in this.subscriptionTickets) {
      return SubscriptionType.Monthly;
    } else if ('yearly' in this.subscriptionTickets) {
      return SubscriptionType.Yearly;
    } else {
      return SubscriptionType.Permanent;
    }
  }
}
